import { createContext, useContext, useState, useCallback } from "react";
import { storage } from "../services/storage";

const AppContext = createContext(null);

const PREFERENCES_KEY = "user_preferences";

export function AppProvider({ children }) {
  const [preferences, setPreferencesState] = useState(() => {
    return (
      storage.get(PREFERENCES_KEY) || {
        defaultPersona: null,
        theme: "light",
        recentSearches: [],
        showSamplePrompts: true,
      }
    );
  });

  const setPreferences = useCallback((updates) => {
    setPreferencesState((prev) => {
      const newPrefs = typeof updates === "function" ? updates(prev) : { ...prev, ...updates };
      storage.set(PREFERENCES_KEY, newPrefs);
      return newPrefs;
    });
  }, []);

  const addRecentSearch = useCallback(
    (search) => {
      setPreferences((prev) => ({
        ...prev,
        recentSearches: [search, ...prev.recentSearches.filter((s) => s !== search)].slice(0, 10),
      }));
    },
    [setPreferences]
  );

  const value = {
    preferences,
    setPreferences,
    addRecentSearch,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useApp must be used within AppProvider");
  }
  return context;
}
